import {Action} from '@ngrx/store';
import {ChecklistItem} from '../../../models/checklist-item';

export class GetChecklistItemsSuccessAction implements Action {
  public static readonly type = 'GetChecklistItemsSuccessAction';

  constructor(public checklistItems: ChecklistItem[]) {
  }

  public type = GetChecklistItemsSuccessAction.type;
}
